import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DeviceManagementUser } from '../../app.types';
import { ConfigService } from '../config/config.service';
import { HttpErrorService } from '../http-error.service';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private httpErrorService: HttpErrorService
  ) {}

  getUsers(): Observable<DeviceManagementUser[]> {
    const url = `${this.configService.API_URI}/DeviceManagementUsers`;

    return this.http.get<DeviceManagementUser[]>(url).pipe(
      catchError((err) => {
        this.httpErrorService.handleHttpError(err);
        return of([]);
      })
    );
  }
}
